export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function distance(left, right) {
  return Math.hypot(left.x - right.x, left.y - right.y);
}

export function formatResource(current, max) {
  const safeMax = Math.max(1, Number(max) || 1);
  const safeCurrent = Math.max(0, Math.min(safeMax, Number(current) || 0));
  return { current: safeCurrent, max: safeMax, ratio: safeCurrent / safeMax };
}

export function directionFromDelta(dx, dy) {
  if (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01) {
    return "down";
  }
  const vertical = dy < -0.2 ? "up" : dy > 0.2 ? "down" : "";
  const horizontal = dx < -0.2 ? "left" : dx > 0.2 ? "right" : "";
  return [vertical, horizontal].filter(Boolean).join("_") || horizontal || vertical || "down";
}

export function currentLanguage() {
  return localStorage.getItem("vibe-language") || "en";
}

export function setLanguage(language) {
  localStorage.setItem("vibe-language", language);
}
